import hsFetch from 'hellospa/hs-fetch';
import { VerifyData } from 'hellospa/components/help/snap-engage/snap-engage-iframe';

export async function fetchVerifiedSnapEngageData() {
  const res = await hsFetch('/home/help/snap-engage-hash', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  const resp: VerifyData = await res.json();

  return resp;
}
